module.exports = __webpack_public_path__ + "img/mage.723c0e59.png";